import { triggerBlobDownload } from "./downloadFilename";

export async function downloadFileFromUrl(
  url: string,
  fileName: string
): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) throw new Error("The file could not be downloaded.");
  const blob = await response.blob();
  triggerBlobDownload(blob, fileName);
}
